// §84 review editor toolbar – a thin browser-API leaf (per the declarative-Datastar
// discipline: JS reports into signals, never fetches or renders). It wraps the
// current textarea selection in markdown syntax and dispatches an `input` event so
// Datastar re-syncs the bound `reviewMd` signal and the debounced live-preview @post
// fires. All rendering stays server-side (the safe goldmark pipeline).
function mdWrap(id: string, before: string, after: string): void {
  const ta = document.getElementById(id) as HTMLTextAreaElement | null;
  if (!ta) return;
  const start = ta.selectionStart;
  const end = ta.selectionEnd;
  const sel = ta.value.slice(start, end);
  ta.value = ta.value.slice(0, start) + before + sel + after + ta.value.slice(end);
  // Re-select the wrapped text so a follow-up format nests predictably.
  ta.focus();
  ta.selectionStart = start + before.length;
  ta.selectionEnd = start + before.length + sel.length;
  ta.dispatchEvent(new Event('input', { bubbles: true }));
}

window.__mdWrap = mdWrap;

export {};
